interface RequestOptions {
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
    jsonBody?: unknown;
    formData?: FormData;
    rawBody?: BodyInit;
    credentials?: RequestCredentials;
    parse?: 'json' | 'text' | 'response';
    signal?: AbortSignal;
}

export async function request<T>(url: string, opts: RequestOptions = {}): Promise<T> {
    // The proxy authenticates by the session cookie, which lives on the API's (cross-origin) domain
    const { method = 'GET', jsonBody, formData, rawBody, credentials = 'include', parse = 'json', signal } = opts;

    const init: RequestInit = { method, credentials };
    if (signal) {
        init.signal = signal;
    }
    if (jsonBody !== undefined) {
        init.body = JSON.stringify(jsonBody);
        init.headers = { 'Content-Type': 'application/json' };
    } else if (formData) {
        init.body = formData;
    } else if (rawBody !== undefined) {
        init.body = rawBody;
    }

    const response = await fetch(url, init);

    if (parse === 'response') {
        return response as unknown as T;
    }

    if (!response.ok) {
        const errText = await response.text();
        throw new Error(errText);
    }

    if (parse === 'text') {
        return (await response.text()) as unknown as T;
    }
    return (await response.json()) as T;
}
